import { corporateCMSApi } from "~/Services";
import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

// Function to generate fields for the news module
export const generateFieldsForNewsApi = (newsCards: any): ModuleFields[] => {
  console.log("news-fields", newsCards);
  return [
    {
      fieldName: "Latest News Text (EN)",
      fieldValue: "field_latest_news_text",
      className: "col-span-6",
      type: "text",
      name: "field_latest_news_text",
      formType: "input",
      label: "Latest News Text (EN)",
      placeholder: "Enter Latest News Text (EN)",
      validation: { required: "Latest News Text (EN) is Required" },
    },
    {
      fieldName: "Latest News Text (MS)",
      fieldValue: "field_latest_news_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_latest_news_text_ms",
      formType: "input",
      label: "Latest News Text (MS)",
      placeholder: "Enter Latest News Text in Malay",
    },
    {
      fieldName: "Latest News Text (ZH)",
      fieldValue: "field_latest_news_text_zhans",
      className: "col-span-6",
      type: "text",
      name: "field_latest_news_text_zhans",
      formType: "input",
      label: "Latest News Text (ZH)",
      placeholder: "Enter Latest News Text in Chinese",
    },
    // {
    //   fieldName: "News Cards",
    //   fieldValue: "view",
    //   type: "dynamicRow",
    //   className: "col-span-12",
    //   name: "view",
    //   formType: "dynamicRow",
    //   dynamicFormType: "dynamicRow",
    //   placeholder: "",
    //   label: "News Cards",
    //   rowConfig: newsCards.map((_: any, cardIdx: number) => ({
    //     fields: [
    //       {
    //         fieldName: `Image ${cardIdx + 1}`,
    //         fieldValue: `view[${cardIdx}].image`,
    //         className: "col-span-6",
    //         type: "image",
    //         name: `view[${cardIdx}].image`,
    //         formType: "file",
    //         usedFileType: "image/*",
    //         label: `Image ${cardIdx + 1}`,
    //         placeholder: "Upload News Image",
    //         validation: { required: "Image is Required" },
    //       },
    //       {
    //         fieldName: `Header ${cardIdx + 1}`,
    //         fieldValue: `view[${cardIdx}].header`,
    //         className: "col-span-6",
    //         type: "text",
    //         name: `view[${cardIdx}].header`,
    //         formType: "richText",
    //         label: `Header ${cardIdx + 1}`,
    //         placeholder: "Enter News Header",
    //         validation: { required: "Header is Required" },
    //       },
    //       {
    //         fieldName: `Date ${cardIdx + 1}`,
    //         fieldValue: `view[${cardIdx}].date`,
    //         className: "col-span-6",
    //         type: "date",
    //         name: `view[${cardIdx}].date`,
    //         formType: "date",
    //         label: `Date ${cardIdx + 1}`,
    //         placeholder: "Select Date",
    //         validation: { required: "Date is Required" },
    //       },
    //       {
    //         fieldName: `Description ${cardIdx + 1}`,
    //         fieldValue: `view[${cardIdx}].description`,
    //         className: "col-span-6",
    //         type: "text",
    //         name: `view[${cardIdx}].description`,
    //         formType: "richText",
    //         label: `Description ${cardIdx + 1}`,
    //         placeholder: "Enter News Description",
    //         validation: { required: "Description is Required" },
    //       },
    //     ],
    //   })),
    // },
    // {
    //   fieldName: "Published",
    //   fieldValue: "published",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "published",
    //   formType: "checkbox",
    //   label: "Published",
    //   placeholder: "Enter Published",
    //   // validation: { required: "Publish is required" },
    // }
  ];
};

// Placeholder for fetched data
export let getNewsData: { [key in ModuleConfig]: ModuleFields[] } | null = null;

// Fetch function to retrieve news data
const fetchNewsApiData = async (id: any): Promise<{ [key in ModuleConfig]: ModuleFields[] } | null> => {
  try {
    if (!id) {
      const basicNewsCard = [
        {
          fields: [
            {
              fieldName: "Image 1",
              fieldValue: "view[0].image",
              className: "col-span-6",
              type: "image",
              name: "view[0].image",
              formType: "file",
              usedFileType: "image/*",
              label: "Image 1",
              placeholder: "Upload News Image",
              validation: { required: "Image is Required" },
            },
            {
              fieldName: "Header 1",
              fieldValue: "view[0].header",
              className: "col-span-6",
              type: "text",
              name: "view[0].header",
              formType: "richText",
              label: "Header 1",
              placeholder: "Enter News Header",
              validation: { required: "Header is Required" },
            },
            {
              fieldName: "Date 1",
              fieldValue: "view[0].date",
              className: "col-span-6",
              type: "date",
              name: "view[0].date",
              formType: "date",
              label: "Date 1",
              placeholder: "Select Date",
              validation: { required: "Date is Required" },
            },
            {
              fieldName: "Description 1",
              fieldValue: "view[0].description",
              className: "col-span-6",
              type: "text",
              name: "view[0].description",
              formType: "richText",
              label: "Description 1",
              placeholder: "Enter News Description",
              validation: { required: "Description is Required" },
            },
          ],
        },
      ];
      const basicFields = generateFieldsForNewsApi(basicNewsCard);
      return {
        latestNews: basicFields.flat() as ModuleFields[],
      };
    }

    const res = await corporateCMSApi.get(`/api/malaysia-airports-training-academy6/${id}`);
    const newsData = res.data;
    console.log("newsDataaaaaaaaa", newsData);
    const fields = generateFieldsForNewsApi(newsData?.[0]?.view || []) || [];

    return {
      latestNews: fields.flat() as ModuleFields[],
    };
  } catch (error) {
    console.error("Error fetching news data:", error);
    return null;
  }
};

export const getNewsDrilldownData = async (id: any) => {
  const getNewsData = await fetchNewsApiData(id);
  return getNewsData;
};
